import { ValidationStrings } from './../../dataProvider/localize'

export const validate = values => {
    const errors = {}
    if (!values.name) {
        errors.name = ValidationStrings.role_validation_name
    }
    return errors
}
